import { motion } from "framer-motion";
import { getPublishedPosts, getFeaturedPosts } from "../data/blogPosts";
import BlogCard from "../components/BlogCard";
import PageLayout from "../components/PageLayout";
import { useSEO } from "../hooks/useSEO";

const Blog = () => {
  const featuredPosts = getFeaturedPosts();
  const allPosts = getPublishedPosts();

  // Set SEO meta tags for blog listing page
  useSEO({
    title: "Sera Blog - Insights on Focus, Productivity & Digital Wellness",
    description: "Discover strategies, tips, and insights to help you build better focus habits and create a healthier relationship with technology.",
    keywords: "productivity, focus, digital wellness, notification management, technology habits, mindfulness",
    author: "Sera Team",
    canonical: "https://sera.app/blog",
    ogTitle: "Sera Blog - Insights on Focus, Productivity & Digital Wellness",
    ogDescription: "Discover strategies, tips, and insights to help you build better focus habits and create a healthier relationship with technology.",
    ogImage: "https://sera.app/og-image.png",
    ogUrl: "https://sera.app/blog",
    twitterTitle: "Sera Blog - Insights on Focus, Productivity & Digital Wellness",
    twitterDescription: "Discover strategies, tips, and insights to help you build better focus habits and create a healthier relationship with technology.",
    twitterImage: "https://sera.app/og-image.png"
  });

  return (
    <PageLayout showCTA={true}>
      {/* Hero Section */}
      <motion.section
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="pt-24 pb-16 px-4 sm:px-6 lg:px-8"
      >
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Insights on Focus, Productivity & Digital Wellness
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto">
            Discover strategies, tips, and insights to help you build better focus habits and create a healthier relationship with technology.
          </p>
        </div>
      </motion.section>

      {/* Featured Posts */}
      <motion.section
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
        className="py-12 px-4 sm:px-6 lg:px-8"
      >
        <div className="max-w-6xl mx-auto">
          <h3 className="text-2xl font-bold mb-8 text-center">Featured Posts</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {featuredPosts.map((post, index) => (
              <BlogCard
                key={post.id}
                post={post}
                variant="featured"
                animationDelay={0.6 + index * 0.1}
              />
            ))}
          </div>
        </div>
      </motion.section>

      {/* All Posts */}
      <motion.section
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8 }}
        className="py-12 px-4 sm:px-6 lg:px-8 bg-slate-800/30"
      >
        <div className="max-w-6xl mx-auto">
          <h3 className="text-2xl font-bold mb-8 text-center">All Posts</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {allPosts.map((post, index) => (
              <BlogCard
                key={post.id}
                post={post}
                variant="compact"
                animationDelay={1.0 + index * 0.1}
              />
            ))}
          </div>
        </div>
      </motion.section>

    </PageLayout>
  );
};

export default Blog;
